import React from 'react';
import { FelaProvider, ThemeProvider } from '@ycos/fela';
import { themes } from './renderer';

export default ({ renderer, brand = 'mrp', children }) => (
    <FelaProvider renderer={renderer}>
        <ThemeProvider theme={themes[brand]}>{children}</ThemeProvider>
    </FelaProvider>
);
